import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class RegisterLogic extends Component {
  get SELECTORS() {
    return {
      account: '[data-account]',
      passwordGroup: '[data-group-password]',
      passwordInput: '[data-input-password',
      privacy: '[data-privacy-input]',
      consents: '[data-consents]',
      formSubmit: 'button.register',
      newsletter: '[name=newsletter]',
    };
  }

  get CLASSNAMES() {
    return {
      show: 'show',
      disabled: 'disabled',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.account = compEl.$component.querySelector(this.SELECTORS.account);
    this.passwordGroup = compEl.$component.querySelector(this.SELECTORS.passwordGroup);
    this.privacy = compEl.$component.querySelector(this.SELECTORS.privacy);
    this.consents = compEl.$component.querySelector(this.SELECTORS.consents);
    this.formSubmit = compEl.$component.querySelector(this.SELECTORS.formSubmit);
    if (this.consents) {
      this.consentsInputs = this.consents.querySelectorAll('input[type=radio]');
    }
    this.newsletter = compEl.$component.querySelectorAll(this.SELECTORS.newsletter);
    this.TrackingComponent = new TrackingComponent();
  }

  listenAccount() {
    this.account.addEventListener('change', () => {
      if (this.account.checked) {
        this.passwordGroup.classList.add(this.CLASSNAMES.show);
      } else {
        this.passwordGroup.classList.remove(this.CLASSNAMES.show);
      }
    });
  }

  listenPrivacy() {
    this.privacy.addEventListener('change', () => {
      // privacy checker
      this.privacyChecker();
      // submit checker
      this.submitFormChecker();
    });
  }

  privacyChecker() {
    if (this.privacy.checked) {
      this.consents.classList.remove(this.CLASSNAMES.disabled);
      this.consentsInputs.forEach(input => {
        input.disabled = false;
      });
    } else {
      this.consents.classList.add(this.CLASSNAMES.disabled);
      this.consentsInputs.forEach(input => {
        input.disabled = true;
      });
    }
  }

  listenPrivacyRadios() {
    this.consentsInputs.forEach(consentsInput => {
      consentsInput.addEventListener('click', () => {
        this.submitFormChecker();
      });
    });
  }

  submitFormChecker() {
    // init var
    let enableSubmit = 0;
    // loop the radios
    this.consentsInputs.forEach(consentsInput => {
      // if checked
      if (consentsInput.checked) enableSubmit = enableSubmit + 1;
    });
    // if the radios are all enabled
    if (enableSubmit == (this.consentsInputs.length / 2) && this.privacy.checked) {
      this.formSubmit.disabled = false;
    } else {
      this.formSubmit.disabled = true;
    }
  }

  bindTracking() {
    this.newsletter.forEach(toggle => {
      toggle.addEventListener('click', () => this.toggleSubmitTracking(toggle));
    });
    this.country = document.getElementsByTagName('body')[0].dataset.website;
    this.formSubmit.addEventListener('click', () => {
      this.TrackingComponent.actions.signup({ country: this.country });
    });
  }

  toggleSubmitTracking(toggle) {
    if (toggle.value === 'no') {
      delete this.formSubmit.dataset.trackingAction;
    }
    if (toggle.value === 'yes') {
      this.formSubmit.dataset.trackingAction = 'newsletterSubscribe';
    }
  }

  bindEvents() {
    // dom ready
    $(document).ready(() => {
      // check
      this.submitFormChecker();
      // privacy checker
      this.privacyChecker();
    });
    //track newsletter subscribe
    this.bindTracking();
  }

  render() {
    this.log('Load logics...');
    this.bindEvents();
    //
    if (this.account && this.passwordGroup) {
      this.listenAccount();
    }
    // enable privacy consents
    if (this.privacy && this.consents) {
      this.listenPrivacy();
    }
    // enable submit
    if (this.consentsInputs) {
      this.listenPrivacyRadios();
    }
  }

}
